import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MenuItemGroupContext from '../menu-item-group/menu-item-group.context';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {boolean} [active]
 * @prop {string} [className]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifMenuItem = (props) => {
  const { children, className = '', active = false, ...other } = props;
  const menuItemGroup = useContext(MenuItemGroupContext);

  useEffect(() => {
    if (active) {
      menuItemGroup.setMenuOpen(true);
    }
  }, []);

  const classes = classNames({
    'motif-menu-list-item': true,
    'motif-menu-list-item-active': active,
    [className]: true
  });

  return (
    <li className={classes} {...other} data-motif-menu-item>
      {children}
    </li>
  );
};

MotifMenuItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  active: PropTypes.bool
};

export { MotifMenuItem };
